<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card p-0 pt-3">
      <div class="flex justify-content-between pl-3 pr-3" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-exclamation-triangle title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.maintenance' | transloco}}</p>
            <p>{{'menu.descriptions.maintenance' | transloco}}</p>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <p-tabMenu #tab (click)="activateMenu(tab)" *ngIf="tabsVisible" [activeItem]="activeItem"
                   [model]="items" class="hidden xl:inline"></p-tabMenu>
        <p-tabMenu #tab (click)="activateMenu(tab)" *ngIf="tabsVisible" [activeItem]="activeItem"
                   [model]="items" class="xl:hidden">
          <ng-template let-i="index" let-item pTemplate="item">
            <i [className]="item.icon"></i>
          </ng-template>
        </p-tabMenu>
      </div>
    </div>
    <div>
      <app-alarm-definition *ngIf="activeItem.id == 'definition'"></app-alarm-definition>
      <app-alarm-overview *ngIf="activeItem.id == 'overview'"></app-alarm-overview>
    </div>
  </div>
</div>
